import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { twoFactor } from "../lib/auth-client";
import { Icon } from "../components/Common.jsx";
import AuthThemeToggle from "../components/AuthThemeToggle.jsx";

// Sign-in second step (feature #19). Reached via onTwoFactorRedirect after a
// 2FA-enabled user submits their password. Accepts a TOTP code or a backup code.
export default function TwoFactorPage() {
  const navigate = useNavigate();
  const [code, setCode] = useState("");
  const [useBackup, setUseBackup] = useState(false);
  const [trust, setTrust] = useState(true);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      const fn = useBackup ? twoFactor.verifyBackupCode : twoFactor.verifyTotp;
      const payload = useBackup ? { code: code.trim() } : { code: code.trim(), trustDevice: trust };
      const { error: err } = await fn(payload);
      if (err) throw new Error(err.message || "Invalid code");
      navigate("/app", { replace: true });
    } catch (err) {
      setError(err.message || "Invalid code — please try again.");
      setBusy(false);
    }
  };

  return (
    <div className="auth-page">
      <AuthThemeToggle />
      <div className="auth-form-wrap" style={{ margin: "0 auto" }}>
        <form className="auth-form" onSubmit={submit}>
          <div style={{ width: 52, height: 52, borderRadius: 14, margin: "0 auto 16px", display: "grid", placeItems: "center", background: "rgba(139,92,246,.12)", color: "var(--primary-2)", border: "1px solid rgba(139,92,246,.25)" }}>
            <Icon name="shield-check" size={24} />
          </div>
          <h1 style={{ textAlign: "center" }}>Two-factor authentication</h1>
          <p style={{ textAlign: "center" }}>
            {useBackup ? "Enter one of your backup codes." : "Enter the 6-digit code from your authenticator app."}
          </p>

          {error && (
            <div role="alert" style={{ marginBottom: 16, padding: "10px 14px", borderRadius: 10, fontSize: 13, background: "rgba(239,68,68,0.1)", border: "1px solid rgba(239,68,68,0.4)", color: "#F87171" }}>
              {error}
            </div>
          )}

          <div className="field">
            <label>{useBackup ? "Backup code" : "Authentication code"}</label>
            <input
              className="input"
              inputMode={useBackup ? "text" : "numeric"}
              maxLength={useBackup ? 20 : 6}
              value={code}
              onChange={(e) => setCode(useBackup ? e.target.value : e.target.value.replace(/\D/g, ""))}
              placeholder={useBackup ? "xxxx-xxxx" : "123456"}
              autoFocus
            />
          </div>

          {!useBackup && (
            <label className="checkbox" style={{ marginBottom: 16 }}>
              <input type="checkbox" checked={trust} onChange={(e) => setTrust(e.target.checked)} /> Trust this device for 60 days
            </label>
          )}

          <button className="btn btn-primary" type="submit" disabled={busy || !code} style={{ width: "100%", justifyContent: "center" }}>
            {busy ? "Verifying…" : <>Verify <Icon name="arrow-right" size={16} /></>}
          </button>

          <div className="auth-foot">
            <button type="button" className="linklike" style={{ background: "none", border: "none", color: "var(--primary-2)", fontWeight: 600, cursor: "pointer" }}
              onClick={() => { setUseBackup((b) => !b); setCode(""); setError(""); }}>
              {useBackup ? "Use authenticator app instead" : "Use a backup code"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
